const FILE_TYPES_IMAGE = '.jpg,.gif,.png,.jpeg,.svg,.webp'
const FILE_TYPES_DOCS =
  '.doc,.docx,.ppt,.pptx,.txt,.pdf,.xls,.xlsx,.csv,.ods,.odt,.rtf'

const UNKNOWN_FILE_MIME_TYPE = 'application/octet-stream'

const ALL_FILE_TYPES = `${FILE_TYPES_IMAGE},${FILE_TYPES_DOCS}`

const IMAGE_FILE_MIMES_TYPES = [
  'image/jpeg', // .jpg, .jpeg
  'image/gif', // .gif
  'image/png', // .png
  'image/svg+xml', // .svg
  'image/webp', // .webp
]

const DOCUMENT_FILE_MIMES_TYPES = [
  'application/msword', // .doc
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
  'application/vnd.ms-powerpoint', // .ppt
  'application/vnd.openxmlformats-officedocument.presentationml.presentation', // .pptx
  'text/plain', // .txt
  'application/pdf', // .pdf
  'application/vnd.ms-excel', // .xls
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
  'text/csv', // .csv
  'application/vnd.oasis.opendocument.spreadsheet', // .ods
  'application/vnd.oasis.opendocument.text', // .odt
  'application/rtf', // .rtf
  // UNKNOWN_FILE_MIME_TYPE, // Desconhecido (Não montado)
]

const ALL_FILE_MIMES_TYPES = [
  ...IMAGE_FILE_MIMES_TYPES,
  ...DOCUMENT_FILE_MIMES_TYPES,
]

const BYTES_UNIT = 'bytes'
const KILOBYTE_UNIT = 'kB'
const MEGABYTE_UNIT = 'MB'
const GIGABYTE_UNIT = 'GB'

const BYTE_UNIT_EXPONENT = {
  [BYTES_UNIT]: 2 ** 0,
  [KILOBYTE_UNIT]: 2 ** 10,
  [MEGABYTE_UNIT]: 2 ** 20,
  [GIGABYTE_UNIT]: 2 ** 30,
}

const DEFAULT_FILE_SIZE_LIMIT = 10
const DEFAULT_FILE_SIZE_UNIT = MEGABYTE_UNIT

const MAX_FILE_SIZE =
  DEFAULT_FILE_SIZE_LIMIT * BYTE_UNIT_EXPONENT[DEFAULT_FILE_SIZE_UNIT]

// Caso for utilizar algum parâmetro de arquivo que não exista na lista, favor inclua para validação!
const MIME_TYP_VALIDATION = {
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  gif: 'image/gif',
  svg: 'image/svg+xml',
  webp: 'image/webp',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  ppt: 'application/vnd.ms-powerpoint',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  txt: 'text/plain',
  pdf: 'application/pdf',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  csv: 'text/csv',
  ods: 'application/vnd.oasis.opendocument.spreadsheet',
  odt: 'application/vnd.oasis.opendocument.text',
  rtf: 'application/rtf',
}

const OPENABLE_FILE_MIME_TYPES = [
  'image/jpeg', // .jpg, .jpeg
  'image/gif', // .gif
  'image/png', // .png
  'image/svg+xml', // .svg
  'image/webp', // .webp
  'application/pdf', // .pdf
]

const OPENABLE_FILE_TYPES = ['jpg', 'jpeg', 'gif', 'png', 'svg', 'webp', 'pdf']

const PDF_FILE_TYPE = '.pdf'
const PDF_FILE_MIMES_TYPES = ['application/pdf']

// Atalhos de tipo/mimeType prontos para o método customizado do yup `fileUpload({ fileGroup: '...' })`
const FILE_GROUPS = {
  all: { types: ALL_FILE_TYPES, mimeTypes: ALL_FILE_MIMES_TYPES },
  pdfOnly: { types: PDF_FILE_TYPE, mimeTypes: PDF_FILE_MIMES_TYPES },
  document: { types: FILE_TYPES_DOCS, mimeTypes: DOCUMENT_FILE_MIMES_TYPES },
  image: { types: FILE_TYPES_IMAGE, mimeTypes: IMAGE_FILE_MIMES_TYPES },
}

// Discriminador usado no registro de métodos customizados do yup (configs/yup)
const STRING_SCHEMA_TYPE = 'string'
const MIXED_SCHEMA_TYPE = 'mixed'
const DATE_SCHEMA_TYPE = 'date'

// Usado pelo método customizado do yup `domain()`
const DOMAIN_REGEX = /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

// Usado pelo método customizado do yup `alphanumeric()`
const ALPHANUMERIC_REGEX = /^[a-zA-Z0-9]+$/

// Usado pelo método customizado do yup `strongPassword()`
const STRONG_PASSWORD_REGEX =
  // eslint-disable-next-line no-useless-escape
  /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[ `!*@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]).{8,}$/

export default {
  ALL_FILE_MIMES_TYPES,
  ALL_FILE_TYPES,
  ALPHANUMERIC_REGEX,
  PDF_FILE_TYPE,
  PDF_FILE_MIMES_TYPES,
  BYTE_UNIT_EXPONENT,
  DATE_SCHEMA_TYPE,
  DEFAULT_FILE_SIZE_LIMIT,
  DEFAULT_FILE_SIZE_UNIT,
  DOCUMENT_FILE_MIMES_TYPES,
  DOMAIN_REGEX,
  FILE_GROUPS,
  FILE_TYPES_DOCS,
  FILE_TYPES_IMAGE,
  IMAGE_FILE_MIMES_TYPES,
  MAX_FILE_SIZE,
  MIME_TYP_VALIDATION,
  MIXED_SCHEMA_TYPE,
  OPENABLE_FILE_MIME_TYPES,
  OPENABLE_FILE_TYPES,
  STRING_SCHEMA_TYPE,
  STRONG_PASSWORD_REGEX,
  UNKNOWN_FILE_MIME_TYPE,
}
